module.exports = __webpack_public_path__ + "c8cae415947e54dda78f09b70d72aa25.json";


//////////////////
// WEBPACK FOOTER
// ./src/portal/i18n/pt.json
// module id = 1043
// module chunks = 0